import { render } from "./WarningPopup.vue?vue&type=template&id=58ee278e"
import script from "./WarningPopup.vue?vue&type=script&lang=js"
export * from "./WarningPopup.vue?vue&type=script&lang=js"
script.render = render

export default script